<template>
	not found
</template>

<script>
export default {
	name: 'NotFoundView',
}
</script>